(function() {
    'use strict';

    angular
        .module('app.archivoBNCR')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/archivo-bncr',
                config: {
                    templateUrl: 'app/archivoBNCR/archivoBNCR.html',
                    controller: 'ArchivoBNCR',
                    controllerAs: 'vm',
                    title: 'ArchivoBNCR'
                }
            }
        ];
    }
})();
